import React from "react";
import useBackdropClose from "../../hooks/useBackdropClose";
import { useTranslation } from "react-i18next";
import { formatSlot } from "../caregiverChat";
import {
  Overlay, Modal, Header, ModalTitle, CloseButton,
  StatusLine, Dot, WhenLine, Hint,
  ActionRow, SecondaryButton, JoinButton,
} from "./styles";

/**
 * Aviso previo a entrar en la sala: recuerda revisar cámara y micro.
 * `roleLabel` distingue de quién es la cita ("Patient" / "Therapist"),
 * porque el modal se usa desde los dos lados.
 */
const JoinConsultationModal = ({ session, withLabel, roleLabel, onClose, onJoin }) => {
  const { t } = useTranslation();

  return (
    <Overlay {...useBackdropClose(onClose)}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Header>
          <ModalTitle>{t("consultation.readyModal.title", { name: withLabel })}</ModalTitle>
          <CloseButton onClick={onClose} aria-label={t("consultation.readyModal.close")}>✕</CloseButton>
        </Header>

        <StatusLine>
          <Dot />
          {t("consultation.readyModal.status")}
        </StatusLine>

        <WhenLine>
          {formatSlot(session.scheduled_at)} — {roleLabel} {withLabel}
        </WhenLine>

        <Hint>{t("consultation.readyModal.hint")}</Hint>

        <ActionRow>
          <SecondaryButton onClick={onClose}>
            {t("consultation.readyModal.back")}
          </SecondaryButton>
          <JoinButton onClick={onJoin}>
            {t("consultation.join")}
          </JoinButton>
        </ActionRow>
      </Modal>
    </Overlay>
  );
};

export default JoinConsultationModal;
